export function isAppendPlugin(plugin) {
    return !!plugin.append && typeof plugin.append === 'function';
}
//# sourceMappingURL=append.plugin.js.map